import React from "react";
import {useSelector, useDispatch} from "react-redux";

import loadingGif from '../../../../assets/images/loader.gif';
import {toggleSmsOptOut} from "../../../../store/actions/admission";
import {useToasts} from "react-toast-notifications";

const ToggleSmsOptOutLink = ({admission}) => {
    const dispatch = useDispatch();
    const {toggleSmsOptOutIds} = useSelector(state => state.admission);
    const {addToast} = useToasts();

    const handleToggleSmsOptOut = () => {
        dispatch(toggleSmsOptOut(admission, addToast));
    };

    const isToggling = toggleSmsOptOutIds.indexOf(admission.id) > -1;
    const optOutStatus = admission.sms_opt_out;
    const linkText = optOutStatus ? "Enable SMS messages" : "Disable SMS messages";

    if (isToggling) {
        return (
            <a className="dropdown-item disabled pointer">
                <img src={loadingGif} alt="loading" />{linkText}
            </a>
        );
    } else {
        return (
            <a className="dropdown-item pointer" onClick={handleToggleSmsOptOut}>
                {linkText}
            </a>
        );
    }
}

export default ToggleSmsOptOutLink;